import { render, staticRenderFns } from "./CredenciamentoDocumentosVirtualizacao.vue?vue&type=template&id=3105099a"
import script from "./CredenciamentoDocumentosVirtualizacao.vue?vue&type=script&lang=js"
export * from "./CredenciamentoDocumentosVirtualizacao.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoDocumentosVirtualizacao.vue?vue&type=style&index=0&id=3105099a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports